import React from 'react';
// import { ServicesSectionDetails } from '../../constants/constants';
import {AwardCRS} from '../../assets/images/index';
import { motion } from 'framer-motion'; 
import { Award_Cards } from '../../constants/constants';

const Award= () => {
const splitTextArray = (text) => {
        return text.split("").map((char, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0, y: -10 }} // Start slightly above
            animate={{ opacity: 1, y: 0 }}   // Animate to normal position
            transition={{
              delay: index * 0.05, // Faster staggered effect for characters
              duration: 0.3,
              ease: "easeOut",
            }}
            className="inline-block"
          >
            {char === " " ? "\u00A0" : char} {/* Preserve spaces */}
          </motion.span>
        ));
      };

    return (
        <div>
            <motion.div
                className="bg-cover bg-center bg-no-repeat w-full h-screen min-h-[300px] backdrop-blur-sm"
                                  style={{
                                    backgroundImage: `url(${AwardCRS})`,
                                    backgroundSize: 'cover', // Cover the entire container (ensure the image always covers the space)
                                    backgroundPosition: 'center', // Keep the image centered
                                  }}
                                  initial={{ opacity: 0 }}
                                  animate={{ opacity: 1 }}
                                  transition={{ duration: 1 }}
                                  whileInView={{ opacity: 1, y: 0 }} // Slide in from the top when in view
                                  viewport={{ once: true }} // Triggers animation when in view
                                >
                <div className="flex justify-center items-center my-auto flex-col gap-[15px] fontText">
                    <div className="font-semibold text-[65px] text-[#ffffff] mt-[200px] max-md:text-[42px]">
                        {splitTextArray('AWARDS')}
                    </div>
                </div>
            </motion.div>

            <motion.div className='container flex flex-col justify-center items-center py-[100px]'>
                <div>
                    <h4 className='fontText text-[32px] px-[20px] font-semibold mb-[30px] text-center'>
                        Industry Honors and Awards
                    </h4>
                </div>
                <div className='flex flex-col gap-[20px] items-center max-md:px-[20px]'>
                    <h5 className='fontText text-[18px] font-normal text-center'>
                        {/* {splitTextArray('Whether youre planning a small renovation or a large-scale development, the team at Shree Dattguru Enterprise is here to bring your construction ideas to life. With a commitment to excellence and attention to detail, we provide all kinds of civil construction services that exceed expectations. From groundwork and structural development to finishing touches, we handle every aspect of construction. Browse through our services and find out how we can help create the perfect space for you.')} */}
                        At <strong>Shree Datt Guru Enterprise</strong>, we take pride in our commitment to building high-quality structures that stand the test of time. Over the years, we have been honored with numerous industry awards for our exceptional work across a variety of sectors. Our expertise spans the construction of government schools, commercial buildings, residential complexes, and more. These prestigious accolades recognize our dedication to excellence, innovation, and safety in every project we undertake. We are grateful for the trust placed in us and continue to set the standard in the construction industry.
                    </h5>
                </div>
            </motion.div>
            <motion.div
                    className="container py-[100px]"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 4, delay: 2.5 }}
                    whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                    viewport={{ once: true }}
                >
                    <h4 className='fontText text-[32px] px-[20px] font-semibold mb-[30px] text-center'>
                        Social Responsibility and Community Support
                    </h4>
                    <div>
                    <div className="flex flex-wrap max-md:flex-col items-center justify-center gap-[30px] max-md:gap-[40px]">
                        {Award_Cards.map((item, index) => (
                        <div
                            key={index}
                            className="w-[340px] h-[450px] max-md:w-[300px] max-md:px-[20px] bg-[#F2F0F0] flex flex-col justify-center items-center rounded-[10px] shadow-[#00000040] transform transition-all duration-300 hover:scale-105"
                        >
                            <div className="mt-[20px]">
                            <img src={item.image} alt={item.title} className="w-[104px] h-[104px] min-h-[104px] max-h-[104px] min-w-[104px] max-w-[104px]" />
                            </div>
                            <h4 className="text-[20px] font-semibold TextFont text-center mb-[13px]">{item.title}</h4>
                            <h6 className="max-w-[300px] font-normal TextFont text-[16px] text-center">{item.description}</h6>
                        </div>
                        ))}
                    </div>
                    </div>
                </motion.div>

           
        </div>
    );
};

export default Award;
